import { Command, CommandResult } from '../procedure.interface';
import { Device } from '@/device';
import { InstallProperties } from '@/interfaces/properties.interface';
import { Logger } from '@/logger';
import { AdbSync, encodeUtf8 } from '@yume-chan/adb';
import { ReadableStream } from '@yume-chan/stream-extra';

export class WriteFileCommand implements Command {
  public content: string;
  public path: string;
  public stopOnError: boolean;
  public type: string;

  constructor(path: string, content: string) {
    this.stopOnError = true;
    this.type = 'writeFile';
    this.content = content;
    this.path = path;
  }

  public toLog(): string {
    return `Writing file to ${this.path}`;
  }

  public async execute(device: Device, _logger: Logger, _?: InstallProperties): Promise<CommandResult> {
    if (!device.adb) {
      return Promise.resolve({
        success: false,
        message: 'Not connected',
      });
    }

    const content = this.content;

    const file = new ReadableStream<Uint8Array>({
      start(controller) {
        controller.enqueue(encodeUtf8(content));
        controller.close();
      },
    });

    // Write file
    try {
      const sync: AdbSync = await device.adb.sync();
      await sync.write({
        filename: this.path,
        file,
      });
      await sync.dispose();
    } catch (error: unknown) {
      return Promise.resolve({
        success: false,
        message: (error as Error).message,
      });
    }

    return Promise.resolve({
      success: true,
      message: 'OK',
    });
  }
}
